<div class="carousel-container">
  <swiper-container #swiper init="false">
    <swiper-slide *ngFor="let product of products; let i = index;">
      <div class="product-item text-center">
        <div class="series-label" *ngIf="productSpecificationAttribute(product, 'series')">
          <span [innerHtml]="productSpecificationAttribute(product, 'series') | safeHtml"></span>
        </div>
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <a (click)="productClick(product,  i, 1)" class="image-link">
              <picture>
                <source [attr.defaultImage]="settings?.holdingImage?.small" [attr.lazyLoad]="product.images[0]?.small + '.webp'" type="image/webp" />
                <img [defaultImage]="settings?.holdingImage?.small" (onStateChange)="imageStateChange($event, product, i, 1)" [lazyLoad]="product.images[0]?.small" [alt]="product.name">
              </picture>
            </a>
          </div>
        </div>
        <div class="d-flex flex-row flex-wrap justify-content-start prices" style="position: relative;">
          <div class="flex-100 controls">
            <div class="name-price">
              <div class="d-flex flex-row flex-wrap justify-content-start" style="position: relative;">
                <div class="flex-100">
                  <div class="name">
                    <a (click)="productClick(product, i, 1)" [routerLink]="[product.seName]" class="title">{{product.name}}</a>
                  </div>
                </div>
                <div class="flex-100" style="position: relative;">
                  <div class="d-flex flex-row flex-wrap justify-content-center price">
                    <div *ngIf="product.oldPrice" class="old-price text-muted"><span>{{product.oldPriceDisplay}}</span></div>
                    <div class="new-price">{{product.newPriceDisplay}}</div>
                  </div>
                  <div class="flex-auto ratings-carousel">
                    <app-rating [product]="product" [direction]="'column'"></app-rating>
                  </div>
                </div>
                <div class="flex-100 list-controls">
                  <app-controls-list [productSimple]="product" [listId]="listId" [listName]="'Carousel - ' + carouselName" (onOpenProductDialog)="openProductDialog(product, i, 1)"></app-controls-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
  <div class="swiper-button-prev-products">
    <a name="Previous" Title="Previous" aria-label="Previous" (click)="slidePrev()">
      <mat-icon color="primary">arrow_circle_left</mat-icon>
    </a>
  </div>
  <div class="swiper-button-next-products">
    <a name="Next" Title="Next" aria-label="Next" (click)="slideNext()">
      <mat-icon color="primary">arrow_circle_right</mat-icon>
    </a>
  </div>
</div>
